import React, { useContext, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import AppContext from '../context/AppContext';

import userApi from '../api/user';
import useApi from '../hooks/useApi';

import defPic from '../assets/images/bg.jpg';
const RecommendedUsers = ({ show, onClose, disconnect, account }) => {
  const { theme } = useContext(AppContext);

  const getRecommendedProfiles = useApi(userApi.getRecommendedProfiles);
  const { pathname } = useLocation();
  useEffect(() => {
    getRecommendedProfiles.request();
  }, []);
  console.log(
    'RECOMMENDED PROFILES',
    getRecommendedProfiles.data?.recommendedProfiles
  );
  let users = getRecommendedProfiles.data?.recommendedProfiles;
  return (
    <StyledRecommendedUsers theme_={theme}>
      <div className="users-container">
        <span>
          <h3>Recommended Users</h3>
          {!users
            ? ''
            : users?.map((user, index) => (
                <span className="user" key={index}>
                  <span className="dp">
                    <Link
                      to={`/${user.handle}`}
                      state={{ path: `${pathname}` }}
                    >
                      <img
                        src={user?.picture?.original?.url || defPic}
                        alt="img"
                      />
                    </Link>
                  </span>
                  <span>
                    <Link
                      to={`/${user.handle}`}
                      state={{ path: `${pathname}` }}
                    >
                      {user.handle}
                    </Link>
                  </span>
                </span>
              ))}
        </span>
      </div>
    </StyledRecommendedUsers>
  );
};
const StyledRecommendedUsers = styled.div`
  padding: 1rem 2rem;
  background: ${({ theme_ }) =>
    theme_ ? 'rgb(23, 24, 24,0.9)' : 'rgb(248, 248, 248,0.9)'};
  -moz-box-shadow: 0 0 3px #ccc;
  -webkit-box-shadow: 0 0 3px #ccc;
  box-shadow: 0 0 3px #ccc;
  border-radius: 0.5rem;
  .users-container {
    display: flex;
    flex-flow: column wrap;
    .user {
      display: flex;
      flex-flow: row wrap;
      align-items: center;
      justify-content: flex-start;
      gap: 0.5rem;
      padding: 0rem 0rem;
      padding-top: 1rem;
      font-size: 1.2rem;
      /* -moz-box-shadow: 0 0 3px #ccc;
      -webkit-box-shadow: 0 0 3px #ccc;
      box-shadow: 0 0 3px #ccc;
      clip-path: inset(0px 0px -15px 0px); */
      .dp {
        border-radius: 50%;
        background: grey;
        width: 2.5rem;
        height: 2.5rem;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
`;
export default RecommendedUsers;
